// extracted by mini-css-extract-plugin
module.exports = {"drawer":"FiltersDrawer_drawer__ulETA","title":"FiltersDrawer_title__y0xiA","chipsContainer":"FiltersDrawer_chipsContainer__jTmgX","chips":"FiltersDrawer_chips__sMBSu"};